import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* 品牌简介 */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center shrink-0">
                <i className="ri-play-fill text-xl text-accent-950" />
              </span>
              <span className="text-xl font-black text-background-50">牛牛视频</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              热门影视视频聚合平台，聚合最新电视剧、电影与综艺内容，帮助影视爱好者快速发现并浏览值得一看的作品。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100">
                <i className="ri-wechat-line text-lg" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100">
                <i className="ri-weibo-line text-lg" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100">
                <i className="ri-mail-line text-lg" />
              </span>
            </div>
          </div>

          {/* 分类导航 */}
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">
                影视分类
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/category/tv" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/variety" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  综艺频道
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  全站搜索
                </Link>
              </li>
            </ul>
          </div>

          {/* 关于 */}
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">
              <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
                关于我们
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  平台介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  使用指南
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  意见反馈
                </Link>
              </li>
            </ul>
          </div>

          {/* 声明 */}
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">内容声明</h4>
            <p className="text-sm leading-relaxed text-primary-200">
              本站为影视内容聚合与展示平台，所有影视资料与数据均为演示内容，不含实际视频播放、下载及会员服务。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2026 牛牛视频 niuniu-video.com 版权所有</p>
          <p>本站内容仅供学习与演示使用</p>
        </div>
      </div>
    </footer>
  );
}